import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { CompeonReverseClientInstance } from 'api';
import endpoints from 'api/CompeonReverseApi/endpoints';
import queryKeys from 'constants/queryKeys';

import { BfsDoiMutationResponse, BfsDoiMutationVariables } from '../BfsDoubleOptIn.model';

/**
 * Withdraws a BfS marketing-consent (Widerruf, EBS-64). The applicant reaches
 * this via the withdrawal link in the marketing email; the `token` comes from
 * the URL query string. On success (200, empty body) the BE revokes the consent
 * and sets the `deactivated` CleverReach system field. A 403 means the token is
 * invalid or already revoked (the revocation link has no expiry but is
 * invalidated once used) and surfaces as the error state.
 *
 * This is a public link — authentication comes from the `token` in the body, not
 * from a session. It is sent on `CompeonReverseClientInstance`, whose auth
 * request interceptor adds no `Authorization` header when there is no session
 * (`getAuthorizationToken()` returns `{}`), so anonymous visitors send a bare
 * PATCH with a plain `{ token }` body. The BE deliberately rejects GET so
 * email-client link previews can't trigger it.
 */
export const useWithdrawBfsConsent = createMutation<
  BfsDoiMutationResponse,
  BfsDoiMutationVariables,
  AxiosError
>({
  mutationKey: [queryKeys.bfs.withdrawConsent],
  mutationFn: ({ token }) =>
    CompeonReverseClientInstance.patch(endpoints.CUSTOMERS.BFS_CONSENT_REVOCATION.compose(), {
      token,
    }),
});
